module.exports = __webpack_public_path__ + "img/questionMark.774a15a8.png";